import { Component, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ToastModule, ToastPositionType } from "primeng/toast";
import { UiToastService } from "./shared/components/toast/ui-toast.service";
import { ButtonModule } from "primeng/button";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { CardModule } from "primeng/card";
import { FormsModule } from "@angular/forms";
import { TelemetryService } from "./shared/services/telemetry.service";
import { AuthService } from "./core/authentication/auth.service";
import SyncManager from "./core/sync/sync-manager";
import { Message } from "primeng/message";
import { Dialog } from "primeng/dialog";
import { ModalIcon, UiModalService } from "./shared/components/modal/ui-modal.service";
import { LogViewerModalComponent } from "./shared/components/support-footer/components/log-viewer-modal/log-viewer-modal.component";
import { getEnvironmentName } from "./shared/utils/environment-helper";

const isiOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

@Component({
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    ToastModule,
    ButtonModule,
    ToggleSwitchModule,
    CardModule,
    FormsModule,
    Message,
    Dialog,
    LogViewerModalComponent
  ],
  selector: "app-root",
  styleUrl: "./app.component.scss",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  protected readonly isNonProductionEnvironment = getEnvironmentName() !== "production";
  toastPosition: ToastPositionType = "bottom-right";
  modalIcon = ModalIcon;
  isLoggedIn = false;
  isLogViewerOpen = false;
  offlineWarning: string = `Your browser does not support Service Workers. Offline capabilities are disabled. Please use ${isiOS ? "Safari" : "Chrome"} for the best experience.`;

  constructor(
    protected toast: UiToastService,
    protected telemetryService: TelemetryService,
    protected auth: AuthService,
    protected syncManager: SyncManager,
    protected modal: UiModalService
  ) {

  }

  // Hidden diagnostic entry point for builds where console logging is suppressed (e.g. production).
  // Only registered when needed so it isn't invoked on every keystroke in builds where it's unused.
  private readonly handleGlobalKeydown = (event: KeyboardEvent): void => {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "l") {
      event.preventDefault();
      this.isLogViewerOpen = true;
    }
  };

  // @HostListener("window:resize")
  // setPos() {
  //   const w = window.innerWidth;
  //   this.toastPosition = w <= 767 ? "top-right" : "bottom-right";
  // }

  title = "BqaWeb";

  ngOnInit(): void {
    // this.setPos();
    if (this.isNonProductionEnvironment) {
      window.addEventListener("keydown", this.handleGlobalKeydown);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener("keydown", this.handleGlobalKeydown);
  }

  public hideWarning() {
    this.offlineWarning = "";
  }

  // toast definition - do not remove
  // width = "400px";
  breakpoints = {
    "1024px": {
      right: "16px",
      bottom: "16px",
      width: "400px",
      left: "auto"
    },
    "767px": {
      right: "8px",
      bottom: "8px",
      width: "calc(100% - 16px)",
      left: "auto"
    }
  };

}

